module.exports = __webpack_public_path__ + "static/media/car-tire.2b12bc9e.webp";